import type { ReactNode } from 'react';
import { ThemeProvider } from 'styled-components';
import type { SurfaceRole } from './tokens';

/** Scope ordinary cards, without overriding explicit overlay or reading roles. */
export function SurfaceScope({ role, children }: { role: SurfaceRole; children: ReactNode }) {
  return (
    <ThemeProvider theme={(parent) => ({ ...parent!, surfaceRole: role })}>
      {children}
    </ThemeProvider>
  );
}
